/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FinancialSummaryStatus } from '../../models/financial-summary-status';
import { FinancialSummaryType } from '../../models/financial-summary-type';
import { UpdateProjectFinancialSummaryCommandResult } from '../../models/update-project-financial-summary-command-result';

export interface ApiProjectFinancialSummariesUpdateProjectFinancialSummaryPatch$Params {
      body?: {
'Id'?: string;
'No'?: number;
'Date'?: string;
'FinancialSummaryType'?: FinancialSummaryType;
'ContractorLetterNumber'?: string;
'ContractorLetterDate'?: string;
'ConsultantLetterNumber'?: string;
'ConsultantLetterDate'?: string;
'OwnerLetterDate'?: string;
'OwnerLetterNumber'?: string;
'From'?: string;
'To'?: string;
'TotalItemsValue'?: number;
'VatValue'?: number;
'Status'?: FinancialSummaryStatus;
'StatusDate'?: string;
'ProjectId'?: string;
'FinancialConformityNumber'?: string;
'Attachments'?: Array<Blob>;
}
}

export function apiProjectFinancialSummariesUpdateProjectFinancialSummaryPatch(http: HttpClient, rootUrl: string, params?: ApiProjectFinancialSummariesUpdateProjectFinancialSummaryPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectFinancialSummaryCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectFinancialSummariesUpdateProjectFinancialSummaryPatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateProjectFinancialSummaryCommandResult>;
    })
  );
}

apiProjectFinancialSummariesUpdateProjectFinancialSummaryPatch.PATH = '/api/ProjectFinancialSummaries/UpdateProjectFinancialSummary';
